import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import { connect } from 'react-redux';
import getRoutes from './routes/routes';
import PayoutMaintenance from './components/payout/PayoutMaintenance';

const mapStateToProps = state => {
    const config = state.get('config');
    const headerState = state.get('epicGamesHeader') || {};
    const footerState = state.get('epicGamesFooter') || {};

    return {
        configState: config ? config.toJS() : {},
        footerState: footerState.toJS ? footerState : {toJS: () => {}},
        headerState: headerState.toJS ? headerState : {toJS: () => {}},
        localizationState: state.get('localization'),
        loginState: state.get('user')
    };
};

@connect(mapStateToProps)
class App extends React.Component {
    static propTypes = {
        configState: PropTypes.object,
        localizationState: PropTypes.object,
        location: PropTypes.object.isRequired,
        mobile: PropTypes.bool,
        msie: PropTypes.bool,
        tablet: PropTypes.bool
    };

    render() {
        const {
            configState,
            localizationState,
            location,
            mobile,
            msie,
            tablet
        } = this.props;
        const classes = classNames('content-wrapper', {
            mobile,
            tablet,
            msie
        });
        const messages = localizationState.get('messageProperties');
        return (
            <div className="site-content">
                <Helmet title={messages.get('epic.esport.site_title')} />

                <div className={classes}>
                    { configState.payoutMaintenance ? <PayoutMaintenance /> : getRoutes(location) }
                </div>
            </div>
        );
    }
}

export default withRouter(App);
